export const PRINT_LAYOUT_POS = [
  { label: '外接', value: 1 },
  { label: '内接', value: 2 },
  { label: 'ピクセル等倍', value: 3 },
];